import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';

/* Actions */
import {
	getOrderList,
	saveManageOrdersListBackup
} from '../../../redux/actions';

class UpdateBookedOrderConfirmation extends Component {

	componentWillMount() {
		window.scrollTo(0, 0);
		if(this.props.state.order.updateBookedOrderConfirmationPageData) {
			this.setState({
				updateBookedOrderConfirmationPageData: this.props.state.order.updateBookedOrderConfirmationPageData
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	handleReturnToPreviousPage(e) {
		e.preventDefault();
		const self = this;
		const {
			updateBookedOrderConfirmationPageData: {
				orderNumber
			}
		} = self.state;
		self.props.getOrderList(`accountNumber=${self.props.getSelectedAccountNumber()}&requestType=manageOrders&orderNumber=${orderNumber}&poNumber=&referenceNumber=`, response => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				const manageOrdersListBackup = JSON.parse(JSON.stringify(self.props.state.order.manageOrdersListBackup));
				// update backed up manage order with updated order list which will be having updated data after updating booked orders
				const data = response.responseObject[0];
				const finalData = [];
				manageOrdersListBackup.ordersListResponse.responseObject.forEach(itm => {
					if(itm.orderHeader.orderNumber === self.state.updateBookedOrderConfirmationPageData.orderNumber) {
						finalData.push(data);
					} else {
						finalData.push(itm);
					}
				});
				manageOrdersListBackup.ordersListResponse.responseObject = JSON.parse(JSON.stringify(finalData));
				manageOrdersListBackup.backupOrdersListResponse.responseObject = JSON.parse(JSON.stringify(finalData));
				//Save manage order list into store
				self.props.saveManageOrdersListBackup(JSON.parse(JSON.stringify(manageOrdersListBackup)));
				browserHistory.push('/manageorders');
			}
		});
	}

	checkDBUpdatesY() {
		const self = this;
		const { updateBookedOrderConfirmationPageData } = self.state;
		const items = [];
		updateBookedOrderConfirmationPageData.items.forEach((itm, indx) => {
			if (itm.dbholdflag === 'Y') {
				items.push(
					<span key={indx + 1}>
						<br />{itm.item}
					</span>
				);
			}
		});
		return items.length
			? <p className="bold red">The below models on this order exceed the quoted amount. The order will be placed on hold. Please contact your ASM to request an update to the quote.
				{items}
			</p>
			: null
	}

    render() {
		const self = this;
		const { updateBookedOrderConfirmationPageData } = this.state;
		const { holdServiceFailed = false, orderNumber = '', splitDeliveryServiceFailed = false } = updateBookedOrderConfirmationPageData;
		let cancelledItems = [];
		let newlyAdded = [];
		let holdBackorderItem = [];
		let splitDeliveryItem = [];
		let isSplittedItems = false;
		// let updatedItems = [];
		if(updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.items) {
			// updatedItems = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'update');
			newlyAdded = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'new');
			cancelledItems = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'cancel' && item.originalAction !== 'reduceQty' && item.action !== 'Hold Backorder');
			isSplittedItems = updateBookedOrderConfirmationPageData.items.find(item => item.action === 'cancel' && item.originalAction === 'split') ? true : false;
			holdBackorderItem = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'Hold Backorder');
			splitDeliveryItem = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'Split Delivery');
			const reduceQtyItems = updateBookedOrderConfirmationPageData.items.filter(item => item.originalAction === 'reduceQty') || [];
			cancelledItems = cancelledItems.concat(reduceQtyItems);
		}
        return (
			<div>
				<h1 className="pageTitle">Update Order Confirmation</h1>
				{self.checkDBUpdatesY()}
				{this.props.params.whichAction === 'cancel'
					?<p className="bold red" style={{marginBottom: 0}}>
						Order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber} has been cancelled successfully.
					</p>
					:<div>
						{!holdServiceFailed && !splitDeliveryServiceFailed && cancelledItems && cancelledItems.length === 0 && newlyAdded && newlyAdded.length === 0 && updateBookedOrderConfirmationPageData.deliveryMethod.includes("ADC") && updateBookedOrderConfirmationPageData.isSplitLinePresent
							?<div> 
								<p className="bold red" style={{marginBottom: 0}}>
									Order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber} has been updated successfully.<br/><br/>
									The Following Products have been split on order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber}.
								</p>
								<table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
									<thead>
										<tr>
											<th className="delProd">Product</th>
											<th className="delProdQuantity">Quantity Split</th>
										</tr>
									</thead>
									<tbody>
										{updateBookedOrderConfirmationPageData.items.map((item , index) => {
											if(item.splitLines && item.splitLines !== null){
												return <tr key={index}>
													<td>{item.item}</td>
													<td>{item.splitLines.map(splitLine => splitLine.splitQty).join(" | ")}</td>
												</tr>
											}
										})}
									</tbody>
								</table>
							</div>
							:!holdServiceFailed && !splitDeliveryServiceFailed && cancelledItems && cancelledItems.length === 0 && newlyAdded && newlyAdded.length === 0 
							? <p className="bold red" style={{marginBottom: 0}}>
								Order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber} has been updated successfully.
							</p>
							:null
						}
						{cancelledItems && cancelledItems.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been cancelled from order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber}.
								{isSplittedItems && <span>&nbsp;The products are in your <Link to='/cart'>Cart</Link> to release on a new order.</span>}
							</p>
						}
						{cancelledItems && cancelledItems.length > 0 && <table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
							<thead>
								<tr>
									<th className="delProd">Product</th>
									<th className="delProdDesc">Description</th>
									<th className="delProdQuantity">Quantity<br />Cancelled </th>
								</tr>
							</thead>
							<tbody>
								{cancelledItems.map((item, index) => {
									return <tr key={index}>
										<td className="delProd">{item.item}</td>
										<td className="delProdDesc">{item.itemDescription}</td>
										<td className="delProdQuantity">{item.originalAction === 'reduceQty' ? (item.originalQuantity - item.quantity) : item.quantity}</td>
									</tr>
								})}
							</tbody>
						</table>}
						{newlyAdded && newlyAdded.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been added to order {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber}
							</p>
						}
						{newlyAdded && newlyAdded.length > 0 && <table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
							<thead>
								<tr>
									<th className="delProd">Product</th>
									<th className="delProdDesc">Description</th>
									<th className="delProdQuantity">Quantity</th>
								</tr>
							</thead>
							<tbody>
								{newlyAdded.map((item, index) => {
									return [<tr key={index}>
										<td className="delProd">{item.item}</td>
										<td className="delProdDesc">{item.itemDescription}</td>
										<td className="delProdQuantity">{item.quantity}</td>
									</tr>,
									item.relatedServices ? item.relatedServices.map((item, index) => {
										return <tr key={index}>
											<td className="delProd"> &nbsp; &nbsp; {item.serviceId}</td>
											<td className="delProdDesc">{item.serviceName}</td>
											<td className="delProdQuantity">{item.quantity}</td>
										</tr>
									})
									:null
									]
								})}
							</tbody>
						</table>}
						{holdBackorderItem && holdBackorderItem.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been moved to a Backorder Hold on Reference #{updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.createOrderResponse && updateBookedOrderConfirmationPageData.createOrderResponse.orderNumber}
							</p>
						}
						{holdBackorderItem && holdBackorderItem.length > 0 &&<div>
							<table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
								<thead>
									<tr>
										<th className="delProd">Product</th>
										<th className="delProdDesc">Description</th>
										<th className="delProdQuantity">Quantity</th>
									</tr>
								</thead>
								<tbody>
									{holdBackorderItem.map((item, index) => {
										return [<tr key={index}>
											<td className="delProd">{item.item}</td>
											<td className="delProdDesc">{item.itemDescription}</td>
											<td className="delProdQuantity">{item.quantity}</td>
										</tr>,
										item.relatedServices ? item.relatedServices.map((item, index) => {
											return <tr key={index}>
												<td className="delProd"> &nbsp; &nbsp; {item.serviceId}</td>
												<td className="delProdDesc">{item.serviceName}</td>
												<td className="delProdQuantity">{item.quantity}</td>
											</tr>
										})
										:null
										]
									})}
								</tbody>
							</table>
							{holdServiceFailed && <p className="red">
								Please allow some time for changes to be reflected on the original order {orderNumber}. For very large orders, this could take up to an hour. Resubmitting the changes is not necessary.
							</p>}
						</div>}
						{splitDeliveryItem && splitDeliveryItem.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been moved to a new order on Reference #{updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.createOrderResponse && updateBookedOrderConfirmationPageData.createOrderResponse.orderNumber}
							</p>
						}
						{splitDeliveryItem && splitDeliveryItem.length > 0 &&<div>
							<table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
								<thead>
									<tr>
										<th className="delProd">Product</th>
										<th className="delProdDesc">Description</th>
										<th className="delProdQuantity">Quantity</th>
									</tr>
								</thead>
								<tbody>
									{splitDeliveryItem.map((item, index) => {
										return [<tr key={index}>
											<td className="delProd">{item.item}</td>
											<td className="delProdDesc">{item.itemDescription}</td>
											<td className="delProdQuantity">{item.quantity}</td>
										</tr>,
										item.relatedServices ? item.relatedServices.map((item, index) => {
											return <tr key={index}>
												<td className="delProd"> &nbsp; &nbsp; {item.serviceId}</td>
												<td className="delProdDesc">{item.serviceName}</td>
												<td className="delProdQuantity">{item.quantity}</td>
											</tr>
										})
										:null
										]
									})}
								</tbody>
							</table>
							{splitDeliveryServiceFailed && <p className="red">
								Please allow some time for changes to be reflected on the original order {orderNumber}. For very large orders, this could take up to an hour. Resubmitting the changes is not necessary.
							</p>}
						</div>}
					</div>
				}
				<div>
                   	<p><a href="" onClick={this.handleReturnToPreviousPage.bind(this)}>Return to Previous Screen</a></p>
					<div className="clear" />
             	</div>
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	saveManageOrdersListBackup: (data) => dispatch(saveManageOrdersListBackup(data)),
})

UpdateBookedOrderConfirmation = connect(mapStateToProps, mapDispatchToProps)(UpdateBookedOrderConfirmation);
export default UpdateBookedOrderConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/updateBookedOrderConfirmation.js